import { Loading } from '../../components/Loading';
import { MissionAccountingInfoForm } from '../../forms/MissionAccountingInfo';

import { useInitHandler } from './hooks/useInitHandler.hook';

export const MissionAccountingInit = () => {
  const { handleSuccess, isSubmitting, onInit } = useInitHandler();

  return (
    <>
      {/* eslint-disable-next-line @typescript-eslint/no-unnecessary-type-conversion */}
      {!!isSubmitting && <Loading />}
      <MissionAccountingInfoForm
        onSuccess={handleSuccess}
        submitLabel="Initialiser"
        useSubmitFactory={onInit}
      />
    </>
  );
};
